import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function fetchXPCondition(data) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}events/`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function fetchAllComponents() {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}admin/xp_points/components`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function deleteXPCondition(id) {
  return Vue.axios({
    method: "DELETE",
    url: `${siteConfig.siteURL}admin/xp_points/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function activateXPCondition(id) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}admin/xp_points/activate/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function deactivateXPCondition(id) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}admin/xp_points/deactivate/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function createXPCondition(data) {
  return Vue.axios({
    method: "POST",
    url: `${siteConfig.siteURL}admin/xp_points`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function updateXPCondition(id, data) {
  return Vue.axios({
    method: "PUT",
    url: `${siteConfig.siteURL}admin/xp_points/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
    data,
  })
}

export function fetchXPConditionById(id) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}admin/xp_points/${id}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}

export function fetchActivationStatus(condition_id, uuid) {
  return Vue.axios({
    method: "GET",
    url: `${siteConfig.siteURL}admin/xp_points/activate_xp_condition_status/${condition_id}/${uuid}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.token,
    },
  })
}
